module.exports = __webpack_public_path__ + "img/análise inicial 2.6885338e.webp";